import { Link } from "react-router-dom";
import { Heart, Cpu, Users, MapPin, Phone, Mail } from "lucide-react";

const values = [
  {
    icon: Heart,
    title: "Omsorg i centrum",
    description:
      "Vi kender plejesektoren indefra. Vores navn er inspireret af \"sestra\" – bosnisk for både søster og sygeplejerske. Det afspejler den varme og nærvær, vi bygger vores arbejde på.",
  },
  {
    icon: Cpu,
    title: "Teknologi der understøtter",
    description:
      "Vores system matcher kompetencer hurtigt og præcist, så I altid får den rette profil. Teknologien gør det nemt – men det er menneskene, der gør forskellen.",
  },
  {
    icon: Users,
    title: "Erfaring fra praksis",
    description:
      "Stiftet af en sygeplejerske med mange års erfaring fra Odense Kommune og en IT-konsulent med ekspertise indenfor processoptimering. Sammen forener vi sundhedsfaglig indsigt med moderne teknologi.",
  },
];

export default function About() {
  return (
    <section id="about" className="section py-10 sm:py-14 md:py-18 bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="max-w-2xl">
          <span className="kicker">Om Plejesøstrene</span>
          <h2 className="section-title mt-2">Hvem er Plejesøstrene?</h2>
          <p className="section-subtitle">
            Vi er et vikarbureau med speciale i den kommunale plejesektor.
            Hos os handler det om stabilitet, ordentlighed og et personligt samarbejde.
          </p>
        </div>

        {/* Value cards */}
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {values.map((v) => (
            <div key={v.title} className="card-elevated p-6">
              <div className="w-10 h-10 rounded-lg bg-brand-50 flex items-center justify-center mb-4">
                <v.icon className="text-brand-600" size={20} />
              </div>
              <h3 className="font-semibold text-slate-900 text-base">
                {v.title}
              </h3>
              <p className="mt-2 text-sm text-slate-500 leading-relaxed">
                {v.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8">
          <Link to="/om-os" className="btn btn-ghost btn-lg">
            Lær os bedre at kende
          </Link>
        </div>

        {/* Company info bar */}
        <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3 text-sm text-slate-500">
          <span className="flex items-center gap-2">
            <MapPin size={15} className="text-brand-500" />
            Helgavej 26, 5230 Odense M
          </span>
          <span className="flex items-center gap-2">
            <Phone size={15} className="text-brand-500" />
            89 80 15 15
          </span>
          <span className="flex items-center gap-2">
            <Mail size={15} className="text-brand-500" />
            info@plejesoestrene.dk
          </span>
          <span className="text-slate-400">CVR 45991768</span>
        </div>
      </div>
    </section>
  );
}
